import React, { useEffect, useState } from "react";
import SaveButton from "../../../components/Buttons/SaveButton";
import SelectListField from "../../../components/Fields/SelectListField";
import { FormConfig } from "../../../components/Fields/Types";
import useSelectListOptions from "../../../components/Hooks/SelectListOptionsHook/useSelectListOptions";
import useValidation from "../../../components/Hooks/ValidationHook/useValidation";
import Popup from "../../../components/Popups/Popup";
import { useNotifications } from "../../../contexts/notificationContext";
import ProductCategoryEmployeeModel from "../../../models/ProductCategoryEmployeeModel";
import DataService from "../../../services/data.service";
import { PopupProps } from "../../../types/PopupProps";
import { Result } from "../../../types/Result";

interface Props extends PopupProps {
    productCategoryId: number
}

const AddProductCategoryEmployeePopup: React.FC<Props> = ({ show, onHide, productCategoryId }) => {
    const [serverErrors, setServerErrors] = useState<Result>({ isSuccesful: true, messages: [] });
    const { handleResult, handleException } = useNotifications();
    const [formData, setFormData] = useState<ProductCategoryEmployeeModel>();

    const functionalRoles = useSelectListOptions('api/v1/selectlist/FunctionalRoles', '-- Select workflow role');
    const employees = useSelectListOptions('api/v1/selectlist/EmployeesForFunctionalRole?functionalRoleId=' + formData?.functionalRoleId ?? 0, '-- Select employee');

    useEffect(() => {
        setFormData({
            productCategoryId: productCategoryId,
            functionalRoleId: 0,
            employeeId: 0,
            concurrencyId: ''
        } as ProductCategoryEmployeeModel);
    }, [])

    function submit() {
        if (formData) {
            DataService
                .create<ProductCategoryEmployeeModel>(`api/v1/ProductCategoryEmployees`, formData)
                .then(response => {
                    handleResult(response);
                    setServerErrors(response);
                    if (response.isSuccesful === true) {
                        onHide();
                    }
                })
                .catch(e => handleException(e));
        }
    }

    const formConfig: FormConfig = {
        fields: [
            { name: 'functionalRoleId', label: 'Workflow role', labelSize: 2, validationRules: [{ type: 'isRequired' }] },
            { name: 'employeeId', label: 'Employee', labelSize: 2, validationRules: [{ type: 'isRequired' }] },
        ],
        handleSubmit: submit,
        showErrors: 'always',
    };

    const { getFieldProps, getSubmitButtonProps } = useValidation(formConfig, formData, serverErrors);

    return (
        <Popup show={show} onHide={onHide} size={'lg'} title={'Add employee'} >
            <Popup.Body>
                <SelectListField {...getFieldProps('functionalRoleId')} options={functionalRoles} />
                <SelectListField {...getFieldProps('employeeId')} options={employees} />
            </Popup.Body>
            <Popup.Footer>
                <SaveButton {...getSubmitButtonProps()} text='Add' />
            </Popup.Footer>
        </Popup>
    );
}
export default AddProductCategoryEmployeePopup;